import { render, staticRenderFns } from "./EditEmmaAvatarForm.vue?vue&type=template&id=1242d4f6&"
import script from "./EditEmmaAvatarForm.vue?vue&type=script&lang=ts&"
export * from "./EditEmmaAvatarForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports